export const STD_BENCHMARK_PERCENT = 75;
export const MAX_BENCHMARK_PERCENT = 95;
export const EXTREME_PERCENT = 95;
export const ANIMATE_PERCENT = 95;
